/** Canonical category order for ERAISIK legal fields (v2). */
export const LEGAL_FIELD_CATEGORIES = [
  'Võlad ja makseraskused',
  'Tarbijaõigused',
  'Kahju hüvitamine ja kindlustus',
  'Eluase ja kinnisvara',
  'Perekond',
  'Pärimine',
  'Töösuhted',
  'Suhted riigi ja omavalitsusega',
  'Migratsioon ja kodakondsus',
  'Süüteod',
  'Äriklient',
  'Maine, andmed ja internet',
];

export function compareLegalFieldCategories(a, b) {
  const indexA = LEGAL_FIELD_CATEGORIES.indexOf(a);
  const indexB = LEGAL_FIELD_CATEGORIES.indexOf(b);
  if (indexA === -1 && indexB === -1) {
    return String(a).localeCompare(String(b), 'et');
  }
  if (indexA === -1) return 1;
  if (indexB === -1) return -1;
  return indexA - indexB;
}

export function sortLegalFieldsByCategory(fields) {
  return [...(fields || [])].sort((a, b) => {
    const categoryCompare = compareLegalFieldCategories(
      a.category || '',
      b.category || '',
    );
    if (categoryCompare !== 0) return categoryCompare;
    return (a.name_et || '').localeCompare(b.name_et || '', 'et');
  });
}

export const legalFieldCategoryOptions = [
  { value: '', label: 'Select Category (Optional)' },
  ...LEGAL_FIELD_CATEGORIES.map((category) => ({ value: category, label: category })),
];
